<style lang="scss" scoped>
  .icon {
    &.inline {
      height: 1em;
      width: 1em;
      line-height: 1;
    }
  }
</style>

<template>
  <svg v-if="svg.id" class="icon" :class="{inline: this.inline}">
    <use :xlink:href="`#${svg.id}`"/>
  </svg>
</template>

<script>

export default {
  data: () => ({
    svg: {},
  }),
  props: {
    name: {
      type: String,
      required: true,
    },
    inline: {
      type: Boolean,
      default: true,
    },
    group: {
      type: String,
      default: '',
    },
  },
  watch: {
    /* eslint-disable */
    name: {
      handler() {
        try {
          const icon = require(`@assets/sprites/svg/${this.group ? `${this.group}/` : ''}${this.name}.svg`);
          this.svg = icon.default;
        } catch (e) {
          this.svg = {};
          this.$emit('error');
        }
      },
      immediate: true,
    },
  },
};
</script>
